var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-company-card__container",
    class: {
      mini: _vm.mini
    }
  }, [_c('a', {
    staticClass: "cm-company-card cm-card raised",
    class: {
      mini: _vm.mini
    },
    attrs: {
      "href": _vm.company.url
    }
  }, [(_vm.company.is_hiring) ? _c('div', {
    staticClass: "cm-company-card__hiring"
  }, [_vm._v("\n      " + _vm._s(_vm.translate('hiring')) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.mini) ? _c('div', {
    staticClass: "cm-company-card__banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.company.banner || '/companies/' + _vm.company.id + '/banner',
      "alt": ((_vm.company.name) + " banner"),
      "loading": "lazy"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cm-company-card__info"
  }, [_c('aside', {
    staticClass: "cm-company-card__logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.company.logo,
      "alt": ((_vm.company.name) + " logo"),
      "loading": "lazy"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "cm-company-card__name"
  }, [_c('h3', [_vm._v(_vm._s(_vm.company.name))]), _vm._v(" "), (_vm.location) ? _c('p', {
    staticClass: "cm-company-card__location"
  }, [_vm._v(_vm._s(_vm.location))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "cm-company-card__motto"
  }, [_vm._v(_vm._s(_vm.company.motto))])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77781810","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/company-card.vue
// module id = null
// module chunks = 